/**
 * Get all files from groups
 * @param {*} items
 * @returns {*[]}
 */
export default function getAllFiles(items) {
  return Object.values(items).reduce((result, group) => [...result, ...group], []);
}
